import type { Room } from "livekit-client";

const participantTokens = new WeakMap<Room, string>();

export type LiveKitRoomSessionProof = {
  roomName: string;
  participantIdentity: string;
  capability: string;
};
const sessionProofs = new WeakMap<Room, LiveKitRoomSessionProof>();

/** Keep the server-issued binding, never participant-editable metadata. */
export function rememberLiveKitRoomSessionProof(
  room: Room,
  proof: LiveKitRoomSessionProof | null
): void {
  if (proof) sessionProofs.set(room, proof);
  else sessionProofs.delete(room);
}

export function getLiveKitRoomSessionProof(room: Room): LiveKitRoomSessionProof | null {
  const proof = sessionProofs.get(room);
  return proof?.roomName === room.name &&
    proof.participantIdentity === room.localParticipant.identity
    ? proof
    : null;
}

export function rememberLiveKitRoomParticipantToken(room: Room, token: string): void {
  if (token) participantTokens.set(room, token);
}

export function getLiveKitRoomParticipantToken(room: Room): string | null {
  return participantTokens.get(room) || null;
}
